import { HistoricalPaymentRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateHistoricalPayments = makeValidator({
  FieldParser: HistoricalPaymentRow,
});
